<template>
    <div id="contenedor-principal-plantillas">
        <!-- <div id="contenedor-encabezados-plantillas" class="text-left">
            <h1>PLANTILLAS DE DOCUMENTOS</h1>
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div class="flex-grow-1 pl-3"><h4>Consulta y administración</h4></div>
        </div> -->

        <div id="encabezados-tp">
            <h1>PLANTILLAS DE DOCUMENTOS</h1>
            <h3 style="color: var(--gris-pj);">Consulta y administración</h3>
            <div class="hr-titulo"></div>
        </div>
        <div id="contendor-principal-plantillas" class="container-fluid">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-4">
                    <div class="d-flex justify-content-start">
                        <button  @click="mostrarSeccionAdministarcion = !mostrarSeccionAdministarcion; fitroMarcadorMemoria = null,  marcadoresMemoria = marcadores" type="button" class="btn btn-primary">
                            {{ mostrarSeccionAdministarcion ? 'Ver lista de marcadores' : 'Ocultar lista de marcadores' }}
                        </button>
                    </div>
                </div>
                <!-- item-marcador -->
                <div v-show="!mostrarSeccionAdministarcion" class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-4">
                    <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2 pt-2">
                            <div class="form-group">
                                <input id="fb-marcador" v-model="fitroMarcadorMemoria" placeholder="Buscar marcador" type="text" class="form-control"/>
                            </div>
                        </div>
                    </div>
                    <div v-for="marcador in marcadoresMemoria" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2 pt-2" :key="marcador.MarcadorId">
                        <div class="item-marcador pt-4 pr-2 pb-2 pl-2">
                            <span class="titulo-marcador-item">{{marcador.Nombre}}</span>
                            <div class="form-inline flex-wrap" style="gap: 0.5rem !important;">
                                <span>Texto para word:</span>
                                <span class="descripcion-marcador-item">{{ marcador.TextoParaReemplazar }}</span>
                            </div>
                            <div class="mt-2">
                                <button type="button" @click="copiarTextoMarcador({ textoMarcador: marcador.TextoParaReemplazar })" class="btn btn-md btn-light"><i class="fas fa-link"></i>&nbsp;&nbsp;Copiar texto de marcador</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-show="mostrarSeccionAdministarcion">
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2">
                    <div>
                        <div class="card"  style="margin-top: 3em;">
                            <div class="card-header">
                                <div class="d-flex align-items-center justify-content-between">
                                    <h5><strong>Filtros de búsqueda (opcional)</strong></h5>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <div class="form-group">
                                        <h6 for="fb-nombre">Nombre</h6>
                                        <input id="fb-nombre" v-model="fbNombre" placeholder="Ingrese el nombre de la plantilla" type="text" class="form-control"/>
                                    </div>
                                    <div class="form-group">
                                        <h6>Área encargada</h6>
                                        <C001Area :class="[filtroAreaInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" v-on:valorParaElPadre="evtCambioTipoAreaF" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="'TipoAreaFVAP'" 
                                            :parametros="{ AreaId: tipoAreaIdF }" 
                                            :valorDefinido="tipoAreaIdF" 
                                            :key="'TipoAreaFVAP' + contRenderAreaF"></C001Area>
                                    </div>
                                    <div v-if="this.campoRequeridoEsValido(tipoAreaIdF)" class="form-group">
                                        <div class="form-group">
                                            <h6 for="f-para">Tipo de plantilla</h6>
                                            <CCatalogoGenerico id="fctipo-para" class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioTipoParaFiltro($event)" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoParaVPlantillasFiltro'" 
                                                :valorDefinido="tipoParaFiltro"
                                                :textoOpcionesSingular="'documento.'"
                                                :textoOpcionesPlural="'documentos.'"
                                                :elementosCatalogo="documentosParaPlantillas"
                                                :key="'KCTDPF' + contadorRenderF"></CCatalogoGenerico>
                                        </div>
                                        <div v-if="esTipoCedulaF" class="form-group">
                                            <h6>Cédula</h6>
                                            <C002TiposCedula class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoCedulaFiltro" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoCedulaVADPF'" 
                                                :parametros="{tipoCedulaId: null, jurisdiccionId: null, conInactivos: false}"
                                                :valorDefinido="tipoCedulaIdF"
                                                :key="'KCTipoCedulaVADPF' + contadorRenderF"></C002TiposCedula>
                                        </div>
                                        <div v-if="esTipoResultadoF" class="form-group">
                                            <h6>Resultado</h6>
                                            <C015TiposDeResultado class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoResultadoFiltro" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoResultadoVADPF'" 
                                                :parametros="{TipoResultadoId: null, Nombre: null, ConInactivos: false}"
                                                :valorDefinido="tipoResultadoIdF"
                                                :key="'KCTipoResultadoVEDRF' + contadorRenderF"></C015TiposDeResultado>
                                        </div>
                                        <div v-if="esTipoRazonF" class="form-group">
                                            <h6>Razón</h6>
                                            <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoRazonFiltro" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoDeRazonVADPF'" 
                                                :parametros="{TipoRazonId: null, Nombre: null}"
                                                :valorDefinido="tipoRazonIdF"
                                                :key="'KCTipoDeRazonVADPF' + contadorRenderF"></C022TiposDeRazones>
                                        </div>
                                    </div>
                                    <div class="form-group" style="margin-top:3em;">
                                        <div style="display: flex; align-items: center;">
                                            <h6 style="margin-right: 0.5em;">Rango de fechas: </h6>
                                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                                <label class="btn btn-secondary" @click="conRangoDeFechas = true, textoLFechaFiltro = 'Fecha inicial', fechaInicial = moment().subtract(5, 'days').format('YYYY-MM-DD'), fechaFinal = moment().format('YYYY-MM-DD')">
                                                <input type="radio" name="options" id="radioVisualizarMapaSi" autocomplete="off" checked>Si
                                                </label>
                                                <label class="btn btn-secondary active" @click="conRangoDeFechas = false, textoLFechaFiltro = 'Fecha de registro', fechaInicial = null, fechaFinal = null">
                                                <input type="radio" name="options" id="radioVisualizarMapaNo" autocomplete="off">No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <h6 for="fechaInicial">{{ textoLFechaFiltro }}</h6>
                                        <div class="d-flex justify-content-between">
                                            <input type="date" id="fechaInicial" v-model="fechaInicial" class="form-control" />
                                            <button v-if="!conRangoDeFechas" @click="fechaInicial = null, fechaFinal= null" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-undo-alt"></i></button>
                                        </div>
                                    </div>
                                    <div v-if="conRangoDeFechas" class="form-group">
                                        <h6 for="fechaFinal">Fecha final</h6>
                                        <input type="date" id="fechaFinal" v-model="fechaFinal" class="form-control" />
                                    </div>
                                    <div class="d-flex justify-content-end mt-4">
                                        <button @click="evtBuscarPlantillas" type="button" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-2">
                    <div>
                        <div class="card"  style="margin-top: 3em;">
                            <div class="card-header">
                                <div class="d-flex align-items-center justify-content-between">
                                    <h5><strong>Administración de plantillas</strong></h5>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <div class="d-flex justify-content-between flex-wrap mb-1">
                                        <div class="form-inline flex-wrap" style="gap: 0.6rem !important;">
                                            <div class="pt-2">
                                                <h5 class="form-inline"><strong>Plantillas</strong>&nbsp;&nbsp;<span class="badge bg-primary rounded-pill">{{ plantillasMemoria.length}}</span></h5>
                                            </div>
                                            <div>
                                                <input id="fb-plantillas" style="width: 400px !important;" v-model="fitroPlantillaMemoria" placeholder="Buscar por nombre de plantilla" type="text" class="form-control"/>
                                            </div>
                                        </div>
                                        <div>
                                            <button @click="evtAgregarPlantilla" type="button" class="btn-sm btn-primary btn-agregar ml-2"><i class="fas fa-plus-square"></i>&nbsp;&nbsp;Nueva plantilla</button>
                                        </div>
                                    </div>
                                    <div class="contenedor-plantillas" id="tabla-plantillas">
                                        <div  v-if="plantillasRegistradas.length < 1 && !cargandoPlantillas" class="contenedor-sin-plantillas" >
                                            <div class="text-center">
                                                <i class="fas fa-folder-open" style="font-size: 100px;"></i>
                                                <h6 style="margin-top:2em;">{{mensajeSinPlantillas}}</h6>
                                            </div>
                                        </div>
                                        <div v-if="cargandoPlantillas" class="contenedor-cargando" style="height: 300px ;">
                                            <div class="text-center">
                                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                                <h4 class="mt-4">Cargando Plantillas</h4>
                                            </div>
                                        </div>
                                        <div v-if="!cargandoPlantillas && plantillasRegistradas.length > 0">
                                            <div v-for="(plantilla,index) in plantillasMemoria" :class="[(index == 0) ? 'contenido-descarga-plantilla' : 'contenido-descarga-plantilla mt-2']" :key="index">
                                                <div>
                                                    <div class="d-flex align-items-center">
                                                        <i class="fas fa-file-alt mr-2" style="font-size: 23px;"></i>
                                                        <span style="color: #000000; font-size: 1.3em; font-weight: bold;">{{plantilla.Nombre}}</span>
                                                    </div>
                                                    <div class="mt-2">
                                                        <h6 style="color: black; font-weight: bold;">Tipo plantilla: <strong>{{ obtenerTipoPlantilla({ tipoCedula: plantilla.TipoCedula }) }}</strong></h6>
                                                    </div>
                                                    <div class="mt-2">
                                                        <h6 style="color: var(--verde-pj-100); font-weight: bold;">ID Plantilla: <strong>[{{ plantilla.TipoPlantillaId }}]</strong></h6>
                                                    </div>
                                                </div>
                                                <div>
                                                    <button :id="'btn-descarga-plantilla-' + plantilla.TipoPlantillaId" @click="evtDescargarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-descargar-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-file-download"></i></button>
                                                    <button :id="'btn-ver-plantilla-' + plantilla.TipoPlantillaId" @click="evtVisualizarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-ver-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-eye"></i>&nbsp;&nbsp;Ver</button>
                                                    <button :id="'btn-editar-plantilla-' + plantilla.TipoPlantillaId" @click="evtEditarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-editar-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-edit"></i>&nbsp;&nbsp;Editar</button>
                                                    <button :id="'btn-eliminar-plantilla-' + plantilla.TipoPlantillaId" @click="evtEliminarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-eliminar-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-minus-square"></i>&nbsp;&nbsp;Eliminar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div id="contendor-plantillas" class="area col-12 d-flex justify-content-between">
            <div id="filtros-busqueda" class="contenedor-color-negro" style="width: 29%">
                <h5>Filtros de búsqueda (opcional)</h5>
                <hr />
                <div class="form-group">
                    <div class="form-group">
                        <h6 for="fb-nombre">Nombre</h6>
                        <input id="fb-nombre" v-model="fbNombre" placeholder="Ingrese el nombre de la plantilla" type="text" class="form-control"/>
                    </div>
                    <div class="form-group">
                        <h6>Área encargada</h6>
                        <C001Area :class="[filtroAreaInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" v-on:valorParaElPadre="evtCambioTipoAreaF" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'TipoAreaFVAP'" 
                            :parametros="{}" 
                            :valorDefinido="tipoAreaIdF" 
                            :key="'TipoAreaFVAP' + contRenderAreaF"></C001Area>
                    </div>
                    <div v-if="this.campoRequeridoEsValido(tipoAreaIdF)" class="form-group">
                         <div class="form-group">
                            <h6 for="f-para">Tipo de plantilla</h6>
                            <CCatalogoGenerico id="fctipo-para" class="p-0 m-0" 
                                v-on:valorParaElPadre="evtCambioTipoParaFiltro($event)" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'CTipoParaVPlantillasFiltro'" 
                                :valorDefinido="tipoParaFiltro"
                                :textoOpcionesSingular="'documento.'"
                                :textoOpcionesPlural="'documentos.'"
                                :elementosCatalogo="documentosParaPlantillas"
                                :key="'KCTDPF' + contadorRenderF"></CCatalogoGenerico>
                        </div>
                        <div v-if="esTipoCedulaF" class="form-group">
                            <h6>Cédula</h6>
                            <C002TiposCedula class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoCedulaFiltro" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'CTipoCedulaVADPF'" 
                                :parametros="{tipoCedulaId: null, jurisdiccionId: null, conInactivos: false}"
                                :valorDefinido="tipoCedulaIdF"
                                :key="'KCTipoCedulaVADPF' + contadorRenderF"></C002TiposCedula>
                        </div>
                        <div v-if="esTipoResultadoF" class="form-group">
                            <h6>Resultado</h6>
                            <C015TiposDeResultado class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoResultadoFiltro" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'CTipoResultadoVADPF'" 
                                :parametros="{TipoResultadoId: null, Nombre: null, ConInactivos: false}"
                                :valorDefinido="tipoResultadoIdF"
                                :key="'KCTipoResultadoVEDRF' + contadorRenderF"></C015TiposDeResultado>
                        </div>
                        <div v-if="esTipoRazonF" class="form-group">
                            <h6>Razón</h6>
                            <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoRazonFiltro" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'CTipoDeRazonVADPF'" 
                                :parametros="{TipoRazonId: null, Nombre: null}"
                                :valorDefinido="tipoRazonIdF"
                                :key="'KCTipoDeRazonVADPF' + contadorRenderF"></C022TiposDeRazones>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top:3em;">
                        <div style="display: flex; align-items: center;">
                            <h6 style="margin-right: 0.5em;">Rango de fechas: </h6>
                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                <label class="btn btn-secondary" @click="conRangoDeFechas = true, textoLFechaFiltro = 'Fecha inicial', fechaInicial = moment().subtract(5, 'days').format('YYYY-MM-DD'), fechaFinal = moment().format('YYYY-MM-DD')">
                                <input type="radio" name="options" id="radioVisualizarMapaSi" autocomplete="off" checked>Si
                                </label>
                                <label class="btn btn-secondary active" @click="conRangoDeFechas = false, textoLFechaFiltro = 'Fecha de registro', fechaInicial = null, fechaFinal = null">
                                <input type="radio" name="options" id="radioVisualizarMapaNo" autocomplete="off">No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <h6 for="fechaInicial">{{ textoLFechaFiltro }}</h6>
                        <div class="d-flex justify-content-between">
                            <input type="date" id="fechaInicial" v-model="fechaInicial" class="form-control" />
                            <button v-if="!conRangoDeFechas" @click="fechaInicial = null, fechaFinal= null" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-undo-alt"></i></button>
                        </div>
                    </div>
                    <div v-if="conRangoDeFechas" class="form-group">
                        <h6 for="fechaFinal">Fecha final</h6>
                        <input type="date" id="fechaFinal" v-model="fechaFinal" class="form-control" />
                    </div>
                    <div class="d-flex justify-content-end mt-4">
                        <button @click="evtBuscarPlantillas" type="button" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                    </div>
                </div>
            </div>
            <div id="administracion-plantillas" style="width: 69%">
                <div class="contenedor-color-negro">
                    <h5>Administración de plantillas</h5>
                    <hr />
                    <div class="form-group">
                        <div class="d-flex justify-content-end">
                            <button @click="evtAgregarPlantilla" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-plus-square"></i>&nbsp;&nbsp;Nueva plantilla</button>
                        </div>
                        <div class="contenedor-plantillas" id="tabla-plantillas">
                            <div  v-if="plantillasRegistradas.length < 1 && !cargandoPlantillas" class="contenedor-sin-plantillas" >
                                <div class="text-center">
                                    <i class="fas fa-folder-open" style="font-size: 100px;"></i>
                                    <h6 style="margin-top:2em;">{{mensajeSinPlantillas}}</h6>
                                </div>
                            </div>
                            <div v-if="cargandoPlantillas" class="contenedor-cargando" style="height: 300px ;">
                                <div class="text-center">
                                    <i class="fas fa-spinner fa-spin fa-5x"></i>
                                    <h4 class="mt-4">Cargando Plantillas</h4>
                                </div>
                            </div>
                            <div v-if="!cargandoPlantillas && plantillasRegistradas.length > 0">
                                <div v-for="(plantilla,index) in plantillasRegistradas" :class="[(index == 0) ? 'contenido-descarga-plantilla' : 'contenido-descarga-plantilla mt-2']" :key="index">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <i class="fas fa-file-alt mr-2" style="font-size: 23px;"></i>
                                        <span style="color: #000000; font-weight: bold;">{{plantilla.Nombre}}</span>
                                    </div>
                                    <div>
                                        <button :id="'btn-descarga-plantilla-' + plantilla.TipoPlantillaId" @click="evtDescargarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-descargar-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-file-download"></i></button>
                                        <button :id="'btn-ver-plantilla-' + plantilla.TipoPlantillaId" @click="evtVisualizarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-ver-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-eye"></i>&nbsp;&nbsp;Ver</button>
                                        <button :id="'btn-editar-plantilla-' + plantilla.TipoPlantillaId" @click="evtEditarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-editar-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-edit"></i>&nbsp;&nbsp;Editar</button>
                                        <button :id="'btn-eliminar-plantilla-' + plantilla.TipoPlantillaId" @click="evtEliminarPlantilla($event)" type="button" class="btn-sm btn-primary"><i :id="'i-eliminar-plantilla-' + plantilla.TipoPlantillaId" class="fas fa-minus-square"></i>&nbsp;&nbsp;Eliminar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-alta-plantilla">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario alta de plantilla</h5>
                        <button id="btn-cerrar-formulario-alta-plantilla" @click="evtCerrarFormularioAlta" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 0em 3em 1em 3em;">
                        <div id="contenedor-error-formulario" v-if="mostrarErroresAlta && !this.camposRequeridosValidos()">
                            <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en formulario</h6>
                            <span style="text-align: justify; display:block;">{{ mensajeErrorFormulario }}</span>
                        </div>
                        <div class="row d-flex">
                        <div class="col-7 col-sm-7 col-md-7 col-lg-7 padding-div-low">
                        <div class="form-group">
                            <div class="form-group">
                                <h6>Área encargada&nbsp;
                                    <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(tipoAreaId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(tipoAreaId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C001Area  :class="[CAreaFormInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" v-on:valorParaElPadre="evtCambioTipoArea" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'TipoAreaVAP'" 
                                    :parametros="{ AreaId: tipoAreaIdF }" 
                                    :valorDefinido="tipoAreaId" 
                                    :key="'TipoAreaVAP' + contRenderArea"></C001Area>
                            </div>
                            <div>
                                <div class="form-group">
                                    <h6 for="ctipo-para">Tipo plantilla &nbsp;
                                            <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(tipoPara)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                            <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(tipoPara)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                        <CCatalogoGenerico id="ctipo-para" class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioTipoPara($event)" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="'CTipoParaVPlantillas'" 
                                            :valorDefinido="tipoPara"
                                            :textoOpcionesSingular="'documento.'"
                                            :textoOpcionesPlural="'documentos.'"
                                            :elementosCatalogo="documentosParaPlantillas"
                                            :key="'KCTDP' + contadorRender"></CCatalogoGenerico>
                                </div>
                                <div v-if="esTipoCedula" class="form-group">
                                    <h6>Cédula&nbsp;
                                        <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(tipoCedulaId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(tipoCedulaId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <C002TiposCedula class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoCedula" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="'CTipoCedulaVADP'" 
                                        :parametros="{tipoCedulaId: null, jurisdiccionId: null, conInactivos: false}"
                                        :valorDefinido="tipoCedulaId"
                                        :key="'KCTipoCedulaVADP' + contadorRender"></C002TiposCedula>
                                </div>
                                <div v-if="esTipoResultado" class="form-group">
                                    <h6>Resultado&nbsp;
                                        <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(tipoResultadoId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(tipoResultadoId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <C015TiposDeResultado class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoResultado" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="'CTipoResultadoVADP'" 
                                        :parametros="{TipoResultadoId: null, Nombre: null, ConInactivos: false}"
                                        :valorDefinido="tipoResultadoId"
                                        :key="'KCTipoResultadoVEDR' + contadorRender"></C015TiposDeResultado>
                                </div>
                                <div v-if="esTipoRazon" class="form-group">
                                    <h6>Razón&nbsp;
                                        <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(tipoRazonId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(tipoRazonId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoRazon" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="'CTipoDeRazonVADP'" 
                                        :parametros="{TipoRazonId: null, Nombre: null}"
                                        :valorDefinido="tipoRazonId"
                                        :key="'KCTipoDeRazonVADP' + contadorRender"></C022TiposDeRazones>
                                </div>
                            </div>
                            <div class="form-group">
                                <h6 for="f-titulo-plantilla">Nombre de plantilla&nbsp;
                                    <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(nombrePlantillaF)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(nombrePlantillaF)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input id="f-titulo-plantilla" type="text" placeholder="Ingrese el titulo de la plantilla" v-model="nombrePlantillaF" :class="[mostrarErroresAlta && !this.campoRequeridoEsValido(nombrePlantillaF) ? 'form-control border border-danger' : 'form-control']" />
                            </div>
                            <div class="form-group">
                                <h6 for="f-descripcion-plantilla">Descripción de plantilla</h6>
                                <textarea id="f-descripcion-plantilla" v-model="descripcionPlantillaF" placeholder="Ingrese la descripcion de la plantilla"  rows="4" type="text" class="form-control"/>
                            </div>
                            <div v-if="formularioEstaEditando" class="form-inline mb-3">
                                <h6 for="f-archivo-plantilla">Archivo actual [ {{ nombreArchivoDePlantilla }} ]</h6>
                                <button v-if="!cambiarArchivoPlantilla" @click="cambiarArchivoPlantilla = true" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar archivo</button>
                                <button v-if="cambiarArchivoPlantilla" @click="cambiarArchivoPlantilla = false" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar</button>
                            </div>
                            <div v-if="!formularioEstaEditando || cambiarArchivoPlantilla" class="form-group">
                                <h6 v-if="!formularioEstaEditando" for="f-archivo-plantilla">Archivo de plantilla&nbsp;
                                    <i v-if="mostrarErroresAlta && this.campoRequeridoEsValido(archivoDePlantillaF)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresAlta && !this.campoRequeridoEsValido(archivoDePlantillaF)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="input-archivo-plantilla" :class="[mostrarErroresAlta && !this.campoRequeridoEsValido(archivoDePlantillaF) ? 'form-control border border-danger' : 'form-control']" v-on:change="evtAgregarArchivoPlantilla($event)" accept=".DOCX, .DOC" />
                            </div>
                        </div>
                        </div>
                        <div class="col-5 col-sm-5 col-md-5 col-lg-5 padding-div-low" id="marcadores">
                            <div class="form-group div-form-alta">
                                <h5>Marcadores</h5>
                                <!-- <hr /> -->
                                <ul class="form-group list-group">
                                    <li v-for="marcador in marcadores" class="list-group-item" :key="marcador.MarcadorId">
                                        <div class="form-inline flex-wrap" style="gap: 0.6rem !important;">
                                            <!-- TextoParaReemplazar -->
                                            <div>
                                                <input type="checkbox" class="form-group" :id="marcador.MarcadorId" v-model="listaDeMarcadoresSeleccionados" v-bind:value="marcador.MarcadorId"  />
                                            </div>
                                            <div class="d-flex flex-column" style="gap: 0px;">
                                                <span class="titulo-marcador-item">{{marcador.Nombre}}</span>
                                                <div class="form-inline flex-wrap" style="gap: 0.5rem !important;">
                                                    <span>Texto para word:</span>
                                                    <span class="descripcion-marcador-item">{{ marcador.TextoParaReemplazar }}</span>
                                                </div>
                                            </div>
                                            <br />                                    
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        </div>
                        <div class="d-flex justify-content-end mt-0">
                            <button @click="evtGuardarPlantilla" type="button" class="btn btn-primary btn-agregar ml-2"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-plantillas">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ tituloVisor }}</h5>
                        <button id="btn-cerrar-visor-plantillas" @click="evtCerrarFormularioAlta" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="plantillaSeleccionadaModificar != null">
                            <div>
                                <PDFDocument :url="plantillaSeleccionadaModificar.Ruta" :height="'600px'" :key="'KVPDF' + contRenderVPDF"/>
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import moment from 'moment'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'

export default {
    components: {
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        C002TiposCedula: catalogos.SINOJ.C002TiposCedula,
        C015TiposDeResultado: catalogos.SINOJ.C015TiposDeResultado,
        C022TiposDeRazones: catalogos.SINOJ.C022TiposDeRazones,
        C001Area: catalogos.PJ.C001Area,
        PDFDocument
    },
    data() {
        return {
            moment,
            enumeraciones,
            mostrarErroresAlta: false,
            nombrePlantillaF: null,
            descripcionPlantillaF: null,
            tipoPara: -1,
            documentosParaPlantillas: [],
            contadorRender: 0,
            contadorRenderF: 0,
            tipoResultadoId: -1,
            tipoRazonId: -1,
            tipoCedulaId: -1,
            esTipoCedula: false,
            esTipoResultado: false,
            esTipoRazon: false,
            tipoResultadoIdF: -1,
            tipoRazonIdF: -1,
            tipoCedulaIdF: -1,
            esTipoCedulaF: false,
            esTipoResultadoF: false,
            esTipoRazonF: false,
            fbNombre: null,
            archivoDePlantillaF: null,
            tipoParaFiltro: -1,
            mensajeErrorFormulario: null,
            fechaInicial: null,
            fechaFinal: null,
            mostrarMensajeError: false,
            formularioEstaEditando: false,
            cambiarArchivoPlantilla: false,
            nombreArchivoDePlantilla: '',
            plantillasRegistradas: [],
            plantillaSeleccionadaModificar: null,
            textoLFechaFiltro: 'Fecha de registro',
            conRangoDeFechas: false,
            mensajeSinPlantillas: 'No se ha realizado ninguna busqueda, en el paso 1 presione el boton de Buscar.',
            cargandoPlantillas: false,
            contRenderVPDF: 0, 
            contRenderArea: 0,
            contRenderAreaF:0,
            tituloVisor: '',
            tipoAreaIdF: -1,
            tipoAreaId: -1,
            filtroAreaInformativo: true,
            CAreaFormInformativo: true,
            cargoAreaDeUsuario: false,
            marcadores: [],
            listaDeMarcadoresSeleccionados: [],
            mostrarSeccionAdministarcion: true,
            fitroMarcadorMemoria: null,
            marcadoresMemoria: [],
            fitroPlantillaMemoria: null,
            plantillasMemoria: []
        }
    },
    methods: {   
        obtenerTipoPlantilla: function({ tipoCedula }) {
            let tipoCedulaStr = 'Sin tipo de plantilla'
            if(this.campoRequeridoEsValido(tipoCedula)) {
                tipoCedulaStr = this.campoRequeridoEsValido(tipoCedula.Nombre) ? tipoCedula.Nombre.toUpperCase().trim() : tipoCedulaStr;
            }
            return tipoCedulaStr;
        },
        predicateFiltradoPorSimilitud: function({ comparar, con }) { 
            if(this.campoRequeridoEsValido(con)) {
            if(comparar.toString().toUpperCase().includes(con.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
        copiarTextoMarcador: function({ textoMarcador }) {
            var $temp = $("<textarea>");

            $("body").append($temp);
            
            $temp.val(textoMarcador).select();
            document.execCommand("copy");
            $temp.remove();
        },
        descargarPlantillaBD: function() { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.plantillaSeleccionadaModificar.Ruta}`
            a.click();
        },
        evtDescargarPlantilla: function(evento) {
            const ID_PLANTILLA = evento.target.getAttribute('id');
            this.plantillaSeleccionadaModificar = this.obtenerPlantillaSeleccionada(ID_PLANTILLA);
            this.descargarPlantillaBD();
        },
        evtVisualizarPlantilla: function(evento) {
            const ID_PLANTILLA = evento.target.getAttribute('id');
            this.plantillaSeleccionadaModificar = this.obtenerPlantillaSeleccionada(ID_PLANTILLA);
            this.tituloVisor = (this.plantillaSeleccionadaModificar != null) ? `Plantilla [${this.plantillaSeleccionadaModificar.Nombre}]` : '';
            this.contRenderVPDF ++;
            $('#visor-plantillas').modal('show');
        },
        evtEliminarPlantilla: function(evento) {
            const ID_PLANTILLA = evento.target.getAttribute('id');
            this.plantillaSeleccionadaModificar = this.obtenerPlantillaSeleccionada(ID_PLANTILLA);
            this.informarConfirmacionDeEliminar();
        },
        eliminarPlantillaBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_ELIMINAR = api.SINOJ.sistema.administracion.plantillas.EliminarPlantilla;
            let urlApi = SERVIDOR + METODO_API_ELIMINAR;
            let peticionArchivos = false;
            let objPlantilla = {
                TipoPlantillaId: this.plantillaSeleccionadaModificar.TipoPlantillaId
            }
            let peticionAPI = {
                TipoPlantilla: objPlantilla,
                EsPrueba: false
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            this.cargandoPlantillas = true;
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                            let peticionAPI = {
                                TipoPlantillaId: null,
                                Nombre: null,
                                TipoCedulaId: null,
                                AreaId: (this.campoRequeridoEsValido(this.tipoAreaIdF)) ? this.tipoAreaIdF : null,
                                TipoResultadoId: null,
                                TipoRazonId: null,
                                FechaInicial: null,
                                FechaFinal: null,
                                PlantillasDe: null,
                                ConInactivos: false,
                                EsPrueba: false
                            }
                            this.obtenerPlantillasBD(peticionAPI);
                        }
                        this.cargandoPlantillas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoPlantillas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evtEditarPlantilla: function(evento) { debugger
            const ID_PLANTILLA = evento.target.getAttribute('id');
            this.plantillaSeleccionadaModificar = this.obtenerPlantillaSeleccionada(ID_PLANTILLA);
            this.llenarFormularioConPlantilla(this.plantillaSeleccionadaModificar);
        },
        llenarFormularioConPlantilla: function(plantilla) { debugger
            this.CAreaFormInformativo = true;
            this.nombrePlantillaF = plantilla.Nombre;
            this.descripcionPlantillaF = plantilla.Descripcion;
            const RUTA_ARCHIVO = plantilla.Ruta.split('\\');
            const NOMBRE_ARCHIVO = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
            this.nombreArchivoDePlantilla =` ${NOMBRE_ARCHIVO}`;
            this.tipoAreaId = (plantilla.Area != null && plantilla.Area != undefined) ? plantilla.Area.AreaId : -1;
            plantilla.Marcadores.forEach((element) => { this.listaDeMarcadoresSeleccionados.push(element.MarcadorId) });

            switch(true) {
                case (plantilla.TipoCedula != null):
                    this.tipoPara = enumeraciones.sinoj.requierenPlantilla.cedula.llave;
                    this.tipoCedulaId = plantilla.TipoCedula.TipoCedulaId;
                    this.esTipoCedula = true;
                    this.esTipoResultado = false;
                    this.esTipoRazon = false;
                    break;
                case (plantilla.TipoResultado != null):
                    this.tipoPara = enumeraciones.sinoj.requierenPlantilla.resultado.llave;
                    this.tipoResultadoId = plantilla.TipoResultado.TipoResultadoId;
                    this.esTipoCedula = false;
                    this.esTipoResultado = true;
                    this.esTipoRazon = false;
                    break;
                case (plantilla.TipoRazon != null):
                    this.tipoPara = enumeraciones.sinoj.requierenPlantilla.razon.llave;
                    this.tipoRazonId = plantilla.TipoRazon.TipoRazonId;
                    this.esTipoCedula = false;
                    this.esTipoResultado = false;
                    this.esTipoRazon = true;
                    break;
                default:
                    break;
            }
            $('#formulario-alta-plantilla').modal('show');
            this.contRenderArea ++;     
            this.contadorRender ++;
            this.formularioEstaEditando = true;
        },
        obtenerPlantillaSeleccionada: function(plantillaId) {
            let plantilla = null;
            const ID_PLANTILLA_COMPLETO = plantillaId.split('-');
            const ID = ID_PLANTILLA_COMPLETO[ID_PLANTILLA_COMPLETO.length -1];
            this.plantillasRegistradas.filter(p => p.TipoPlantillaId == ID).forEach(tp => {
                plantilla = tp;
            });
            return plantilla;
        },
        obtenerPlantillasBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.catalogos.C009TiposPlantilla;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            this.cargandoPlantillas = true;
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const PLANTILLAS_REGISTRADAS_BD = respuesta.data.TiposPlantilla;
                            this.plantillasRegistradas = (PLANTILLAS_REGISTRADAS_BD != null) ? PLANTILLAS_REGISTRADAS_BD : [];
                            this.plantillasMemoria = this.plantillasRegistradas;
                            console.log('pllll::',this.plantillasMemoria);
                            this.fitroPlantillaMemoria = null;
                            //console.log('PLANTILLAS_REGISTRADAS_BD::',this.plantillasRegistradas);
                            /* // validacion para filtrar plantillas generales, son las que no tienen area
                            if(this.plantillasRegistradas != null && this.plantillasRegistradas != undefined && this.plantillasRegistradas.length > 0) {
                                this.plantillasRegistradas = this.plantillasRegistradas.filter(p => p.Area != null);
                            } */
                        }
                        this.cargandoPlantillas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoPlantillas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        obtenerMarcadores: function(){
            const parametros = {
                EsPrueba: this.enumeraciones.EsPrueba                
            }        

            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

            axios.post(api.conexion + api.SINOJ.catalogos.C028Marcadores, parametros, headerPeticion)
            .then(respuesta => { 
                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                    this.marcadores = respuesta.data.Marcadores;        
                    console.log('MARCADORES::',this.marcadores);  
                    this.marcadoresMemoria = this.marcadores;                       
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })
        }, 
        crearPeticionGuardarPlantilla: function() {
            let peticion = new FormData();
            let tipoPlantillaOBJ = {};
            tipoPlantillaOBJ.TipoPlantillaId = (this.formularioEstaEditando) ? this.plantillaSeleccionadaModificar.TipoPlantillaId : -1;
            tipoPlantillaOBJ.Nombre = this.nombrePlantillaF;
            tipoPlantillaOBJ.Ruta = (this.formularioEstaEditando) ? this.plantillaSeleccionadaModificar.Ruta : null;
            tipoPlantillaOBJ.Area = { AreaId: this.tipoAreaId  };
            tipoPlantillaOBJ.Marcadores = [];
            debugger
            //Se cargan marcadores
            let _this = this;
            this.marcadores.forEach((element, index) => {debugger
                if(_this.listaDeMarcadoresSeleccionados.some(marcador => marcador == element.MarcadorId))
                    tipoPlantillaOBJ.Marcadores.push(element);
            });

            if(this.campoRequeridoEsValido(this.tipoCedulaId)){
                tipoPlantillaOBJ.TipoCedula = { TipoCedulaId: this.tipoCedulaId }
            }
            else if(this.campoRequeridoEsValido(this.tipoResultadoId)){
                tipoPlantillaOBJ.TipoResultado = { TipoResultadoId: this.tipoResultadoId }
            }
            else if(this.campoRequeridoEsValido(this.tipoRazonId)){
                tipoPlantillaOBJ.TipoRazon = { TipoRazonId: this.tipoRazonId }
            }
            tipoPlantillaOBJ.Usuario = null;
            tipoPlantillaOBJ.Activo = true;
            tipoPlantillaOBJ.FechaDeRegistro = null;
            tipoPlantillaOBJ.Descripcion = this.descripcionPlantillaF;
            if(!this.formularioEstaEditando || this.cambiarArchivoPlantilla) {
                peticion.append('Archivo',this.archivoDePlantillaF);
            }
            peticion.append('TipoPlantilla',JSON.stringify(tipoPlantillaOBJ));
            peticion.append('EsPrueba',false);
            /* console.log('VALORES FORMDATA');
            for (var pair of peticion.entries()) {
                console.log(pair[0]+ ', ',pair[1]); 
            } */
            return peticion;
        },
        guardarPlantillaBD: function(peticionAPI) { debugger
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = (this.formularioEstaEditando) ? api.SINOJ.sistema.administracion.plantillas.ModificarPlantilla :api.SINOJ.sistema.administracion.plantillas.GuardarNuevaPlantilla;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#formulario-alta-plantilla').modal('hide');
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta.data.Error);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                            this.evtAgregarPlantilla();
                        } 
                        else {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            comun.SeEstaCargandoInformacion(false);
                            this.limpiarFormularioAlta();
                            let peticionAPI = {
                                TipoPlantillaId: null,
                                Nombre: null,
                                TipoCedulaId: null,
                                AreaId: (this.campoRequeridoEsValido(this.tipoAreaIdF)) ? this.tipoAreaIdF : null,
                                TipoResultadoId: null,
                                TipoRazonId: null,
                                FechaInicial: null,
                                FechaFinal: null,
                                PlantillasDe: null,                                
                                ConInactivos: false,
                                EsPrueba: false
                            }
                            this.obtenerPlantillasBD(peticionAPI);
                        }
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        this.evtAgregarPlantilla();
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        camposRequeridosValidos: function() { debugger
            let camposValidos = true;
            let camposConstantes = [];
            let campos = [{ mensaje:'para que documento es la plantilla.', input: this.tipoPara }];
            if(!this.formularioEstaEditando)
                campos.push({ mensaje:'un area valida..', input: this.tipoAreaId });
            switch(this.tipoPara) {
                case enumeraciones.sinoj.requierenPlantilla.cedula.llave:
                    campos.push({ mensaje:'un tipo de cedula valido.', input: this.tipoCedulaId });
                    break;
                case enumeraciones.sinoj.requierenPlantilla.resultado.llave:
                    campos.push({ mensaje:'un tipo de resultado valido.', input: this.tipoResultadoId });
                    break;
                case enumeraciones.sinoj.requierenPlantilla.razon.llave:
                    campos.push({ mensaje:'un tipo de razon valida.', input: this.tipoRazonId });
                    break; 
                default:
                    break;
            }
            camposConstantes.push({ mensaje:'un nombre de plantilla valido.', input: this.nombrePlantillaF });
            if(!this.formularioEstaEditando || this.cambiarArchivoPlantilla) 
                camposConstantes.push({ mensaje:'un archivo de plantilla (.DOC, .DOCX).', input: this.archivoDePlantillaF });

            campos = campos.concat(camposConstantes);
            for(let i=0; i<campos.length; i++) {
                if(!this.campoRequeridoEsValido(campos[i].input)) {
                    camposValidos = false;
                    this.mensajeErrorFormulario = `Se detectaron campos incorrectos,Debes ingresar ${campos[i].mensaje}`;
                    this.mostrarErroresAlta = true;
                    break;
                }
            }
            return camposValidos;
        },
        limpiarFormularioAlta: function() {
            this.tipoAreaId = -1;
            this.tipoPara = -1,
            this.tipoCedulaId = -1,
            this.tipoResultadoId = -1,
            this.tipoRazonId = -1,
            this.esTipoCedula = false,
            this.esTipoResultado = false,
            this.esTipoRazon = false,
            this.nombrePlantillaF = null,
            this.descripcionPlantillaF = null;
            $("#input-archivo-plantilla").val('');
            this.formularioEstaEditando = false;
            this.cambiarArchivoPlantilla = false;
            this.archivoDePlantillaF = null;
            this.contRenderArea ++;
            this.contadorRender ++;
            this.mostrarErroresAlta = false;
            this.plantillaSeleccionadaModificar = null;
            this.listaDeMarcadoresSeleccionados = [];
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        evtAgregarPlantilla: function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
                this.asignarValoresCatalogosFormulario(this.$store.state.Login_Usuario.Area);
            }
            $('#formulario-alta-plantilla').modal('show');            
        },
        evtBuscarPlantillas: function() {
            let peticionAPI = {
                TipoPlantillaId: null,
                Nombre: this.fbNombre,
                TipoCedulaId: (this.campoRequeridoEsValido(this.tipoCedulaIdF)) ? this.tipoCedulaIdF : null,
                AreaId: (this.campoRequeridoEsValido(this.tipoAreaIdF)) ? this.tipoAreaIdF : null,
                TipoResultadoId: (this.campoRequeridoEsValido(this.tipoResultadoIdF)) ? this.tipoResultadoIdF : null,
                TipoRazonId: (this.campoRequeridoEsValido(this.tipoRazonIdF)) ? this.tipoRazonIdF : null,
                FechaInicial: (this.campoRequeridoEsValido(this.fechaInicial)) ? this.fechaInicial : null,
                FechaFinal: (this.campoRequeridoEsValido(this.fechaFinal) && this.conRangoDeFechas) ? this.fechaFinal : null,
                PlantillasDe: (this.campoRequeridoEsValido(this.tipoParaFiltro)) ? this.tipoParaFiltro : null,
                ConInactivos: false,
                EsPrueba: false
            }
            this.obtenerPlantillasBD(peticionAPI);
            this.mensajeSinPlantillas = (this.mensajeSinPlantillas != 'No se encontraron plantillas') ? 'No se encontraron plantillas' : this.mensajeSinPlantillas;
        },
        evtCerrarFormularioAlta: function() {
            $('#btn-cerrar-formulario-alta-plantilla').trigger('click');
            this.limpiarFormularioAlta();
            //this.CAreaFormInformativo = false;
        },
        evtCambioTipoArea: function(evento) {
            this.tipoAreaId = parseInt(evento.target.value);
            this.tipoPara = -1;
            this.tipoCedulaId = -1;
            this.tipoResultadoId = -1;
            this.tipoRazonId = -1;
            this.contadorRender ++;
            this.esTipoCedula = false;
            this.esTipoResultado = false;
            this.esTipoRazon = false;
        },
        evtCambioTipoAreaF: function(evento) {
            this.tipoAreaIdF = parseInt(evento.target.value);
            this.tipoParaFiltro = -1;
            this.tipoCedulaIdF = -1;
            this.tipoResultadoIdF = -1;
            this.tipoRazonIdF = -1;
            this.contadorRenderF ++;
            this.esTipoCedulaF = false;
            this.esTipoResultadoF = false;
            this.esTipoRazonF = false;
        },
        evtCambioTipoRazon: function(evento) {
            this.tipoRazonId = parseInt(evento.target.value);
        },
        evtCambioTipoResultado: function(evento) {
            this.tipoResultadoId = parseInt(evento.target.value);
        },
        evtCambioTipoCedula: function(evento) {
            this.tipoCedulaId = parseInt(evento.target.value);
        },
        evtCambioTipoRazonFiltro: function(evento) {
            this.tipoRazonIdF = parseInt(evento.target.value);
        },
        evtCambioTipoResultadoFiltro: function(evento) {
            this.tipoResultadoIdF = parseInt(evento.target.value);
        },
        evtCambioTipoCedulaFiltro: function(evento) {
            this.tipoCedulaIdF = parseInt(evento.target.value);
        },
        evtCambioTipoPara: function(evento) { 
            const ID_SELECCION = parseInt(evento.target.value);
            this.tipoPara = ID_SELECCION;
            switch(ID_SELECCION) {
                case enumeraciones.sinoj.requierenPlantilla.cedula.llave:
                    this.esTipoCedula = true;
                    this.esTipoResultado = false;
                    this.esTipoRazon = false;
                    this.limpiarValorDeCatalogosAlta();
                    break;
                case enumeraciones.sinoj.requierenPlantilla.resultado.llave:
                    this.esTipoCedula = false;
                    this.esTipoResultado = true;
                    this.esTipoRazon = false;
                    this.limpiarValorDeCatalogosAlta();
                    break;
                case enumeraciones.sinoj.requierenPlantilla.razon.llave:
                    this.esTipoCedula = false;
                    this.esTipoResultado = false;
                    this.esTipoRazon = true;
                    this.limpiarValorDeCatalogosAlta();
                    break; 
                default:
                    this.esTipoCedula = false;
                    this.esTipoResultado = false;
                    this.esTipoRazon = false;
                    this.limpiarValorDeCatalogosAlta();
                    break;
            }
        },
        limpiarValorDeCatalogosAlta: function() {
            this.tipoCedulaId = -1;
            this.tipoResultadoId = -1;
            this.tipoRazonId = -1;
            this.contadorRender ++;
        },
        evtCambioTipoParaFiltro: function(evento) { 
            const ID_SELECCION = parseInt(evento.target.value);
            this.tipoParaFiltro = ID_SELECCION;
            switch(ID_SELECCION) {
                case enumeraciones.sinoj.requierenPlantilla.cedula.llave:
                    this.esTipoCedulaF = true;
                    this.esTipoResultadoF = false;
                    this.esTipoRazonF = false;
                    this.limpiarValorDeFiltroCatalogo();
                    break;
                case enumeraciones.sinoj.requierenPlantilla.resultado.llave:
                    this.esTipoCedulaF = false;
                    this.esTipoResultadoF = true;
                    this.esTipoRazonF = false;
                    this.limpiarValorDeFiltroCatalogo();
                    break;
                case enumeraciones.sinoj.requierenPlantilla.razon.llave:
                    this.esTipoCedulaF = false;
                    this.esTipoResultadoF = false;
                    this.esTipoRazonF = true;
                    this.limpiarValorDeFiltroCatalogo();
                    break; 
                default:
                    this.esTipoCedulaF = false;
                    this.esTipoResultadoF = false;
                    this.esTipoRazonF = false;
                    this.limpiarValorDeFiltroCatalogo();
                    break;
            }
        },
        limpiarValorDeFiltroCatalogo: function() {
            this.tipoCedulaIdF = -1;
            this.tipoResultadoIdF = -1;
            this.tipoRazonIdF = -1;
            this.contadorRenderF ++;
        },
        evtAgregarArchivoPlantilla: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.archivoDePlantillaF = evento.target.files[0];
                }
                else {
                    this.archivoDePlantillaF = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtGuardarPlantilla: function() {
            if(this.camposRequeridosValidos()) {
                this.mostrarErroresAlta = false;
                let peticionAPI = this.crearPeticionGuardarPlantilla();
                this.guardarPlantillaBD(peticionAPI);
            }
        },
        informarConfirmacionDeEliminar: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas eliminar la plantilla '${this.plantillaSeleccionadaModificar.Nombre}'<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.eliminarPlantillaBD();
                    }
                    else {
                        this.plantillaSeleccionadaModificar = null;
                    }
                }
            });
        },
        asignarValoresCatalogosFormulario: function(areaDeUsuario) {
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                this.tipoAreaId = this.campoRequeridoEsValido(AreaId) ? AreaId : -1;
                const VALOR_EVENTO = {
                    target: { value: this.tipoAreaId }
                };
                // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                this.contRenderArea ++;
                this.CAreaFormInformativo = true;
                this.evtCambioTipoAreaF(VALOR_EVENTO);
            }
            else {
                this.tipoAreaIdF = -1;
                const VALOR_EVENTO = {
                    target: { value: this.tipoAreaIdF }
                };
                this.contRenderArea ++;
                this.CAreaFormInformativo = false;
            }
        },
        asignarValoresEnCatalogos: async function(areaDeUsuario) { 
            this.plantillasRegistradas = [];
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                this.tipoAreaIdF = this.campoRequeridoEsValido(AreaId) ? AreaId : -1;
                const VALOR_EVENTO = {
                    target: { value: this.tipoAreaIdF }
                };
                // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                this.contRenderAreaF ++;
                this.filtroAreaInformativo = true;
                this.evtCambioTipoAreaF(VALOR_EVENTO);
            }
            else {
                this.tipoAreaIdF = -1;
                const VALOR_EVENTO = {
                    target: { value: this.tipoAreaIdF }
                };
                this.contRenderAreaF ++;
                this.filtroAreaInformativo = false;
            }
        },
        asignarValoresDeUsuario: async function(areaDeUsuario) {
            await Promise.resolve(this.asignarValoresEnCatalogos(areaDeUsuario));
            let peticionAPI = {
                TipoPlantillaId: null,
                Nombre: null,
                TipoCedulaId: null,
                AreaId: (this.campoRequeridoEsValido(this.tipoAreaIdF)) ? this.tipoAreaIdF : null,
                TipoResultadoId: null,
                TipoRazonId: null,
                FechaInicial: null,
                FechaFinal: null,
                PlantillasDe: null,
                ConInactivos: false,
                EsPrueba: false
            }
            this.obtenerPlantillasBD(peticionAPI);
        }
    },
    created() {
        const REQUIEREN_DE_PLANTILLA = enumeraciones.sinoj.requierenPlantilla;
        this.documentosParaPlantillas = [REQUIEREN_DE_PLANTILLA.cedula, REQUIEREN_DE_PLANTILLA.resultado, REQUIEREN_DE_PLANTILLA.razon];
        this.obtenerMarcadores();
    },
    
    async mounted() { 
        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            await Promise.resolve(this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area));
        }
        $("#fb-marcador").on("change paste keyup", (e) => {
            //console.log('entroEvt')
            if(this.marcadores.length > 0) {
                this.marcadoresMemoria = this.marcadores.filter(m => this.predicateFiltradoPorSimilitud({ comparar: m.TextoParaReemplazar, con: this.fitroMarcadorMemoria }))
            }
        });
         $("#fb-plantillas").on("change paste keyup", (e) => {
            console.log('entroEvt')
            if(this.plantillasRegistradas.length > 0) {
                this.plantillasMemoria = this.plantillasRegistradas.filter(p => this.predicateFiltradoPorSimilitud({ comparar: p.Nombre, con: this.fitroPlantillaMemoria }))
            }
        });
    },
     watch: {
        '$store.state.Login_Usuario.Area': function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
            }
        }
    }
}
</script>
<style scoped>
.item-marcador {
    /* background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    color: black; */

     background-color: var(--gris-pj);
     border: 1px solid rgb(129, 129, 129) !important;
     color: black;
}

.list-group-item {
    background-color: rgb(219, 219, 219) !important;
    color: black !important;
}

.titulo-marcador-item {
    /* font-weight: bold; */
    font-size: 1.2rem;
}

.descripcion-marcador-item {
    font-weight: bold;
    font-size: 1rem;
    /* color: rgb(207, 2, 2) !important; */
}
/* ESILOS NUEVOS */
#contenedor-principal-plantillas .modal-lg {
    max-width: 60% !important;
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color: var(--verde-pj-100);
}


#contendor-principal-plantillas .card-header {
    background-color: rgb(70, 70, 70);
}

#contendor-principal-plantillas .card-body {
    background-color: rgb(49, 49, 49);
}

#contendor-principal-plantillas .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

.div-form-alta {
     /* border-left: 2px solid rgb(129, 129, 129) !important;
     padding-left: 2em; */
}
/* FIN ESTILOS NUEVOS */
#visor-plantillas .modal-lg {
    max-width: 70% !important;
}

.modal-header {
    background-color: var(--verde-pj) !important;
    border: none;
}

.contenido-descarga-plantilla {
    padding: 5px 9px 5px 9px;
    border-radius: 4px;
    background-color: #817c7c;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.contenedor-plantillas {
    /* background-color: #242425; */
    border: 1px solid rgba(143,142,142,0.75);
    box-shadow: -7px 8px 3px -1px rgba(143,142,142,0.36);
    max-height: 30em;
    overflow-y: auto;
    padding: 12px;
    border-radius: 4px;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

textarea {
    padding: 0.6em !important;
}

.btn-agregar {
    color: #fff !important;
   /*  background-color: #007bff !important;
    border-color: #007bff !important; */
}

.btn-agregar:hover,
.btn-agregar:focus {
    color: #fff !important;
    /* background-color: #0064cf !important;
    border-color: #0064cf !important; */
}

.btn-sm {
    cursor: pointer;
    padding: 6px 10px 6px 10px;
    background-color: #555558;
}

.btn-sm:hover {
    background-color: black;
}

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.contenedor-sin-plantillas {
    /* background-color: rgb(36, 34, 34); */
    height: 17rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-cargando {
    /* background-color: rgb(36, 34, 34); */
    height: 17rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

#marcadores ul {
      overflow-y: auto;
      max-height: 390px;
    }

#marcadores ul li {
    background-color: #504f54;
    border: 1px solid rgba(0,0,0,.125);
}

#contenedor-principal-plantillas .card-header {
    background-color: var(--verde-pj);
}

#contenedor-principal-plantillas .card-body {
    background-color: var(--gris-pj-100);
}

#contenedor-principal-plantillas .card-body h5, #contenedor-principal-plantillas .card-body h6 {
    color: black;
}

#contenedor-principal-plantillas .btn-primary {
    background-color: var(--verde-pj-100);
}

#formulario-alta-plantilla .modal-header {
    background-color: var(--verde-pj) !important;
}

.modal-body {
    background-color: var(--gris-pj-100);
}

.modal-body h5, .modal-body h6 {
    color: black;
}

.rounded-pill {
    background-color: var(--verde-pj) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Administracion/Plantillas/CPlantillas.vue